import {
  VTextField,
  VTextarea,
  VSelect,
  VAutocomplete,
  VSwitch,
} from 'vuetify/components';

//import DynamicJsonField from '@/components/form/DynamicJsonField.vue'
  
import type { FormField } from '@/types/form';

export const CREATE_FORM: FormField[] = [
  { value: 'title', label: 'Título', component: VTextField, required: true, col: 6 },

  { value: 'is_published', label: 'Publicado', component: VSwitch, col: 6 },

  { value: 'price', label: 'Precio', component: VTextField, type: 'number', prefix: '$', required: true, col: 6 },
  { value: 'discount_price', label: 'Precio de descuento', component: VTextField, type: 'number', prefix: '$', col: 6 },
  { value: 'down_payment', label: 'Enganche', component: VTextField, type: 'number', prefix: '$', col: 6 },

  { value: 'mileage', label: 'Kilometraje', component: VTextField, type: 'number', suffix: 'km', col: 6 },

  { value: 'short_description', label: 'Descripción corta', component: VTextField, col: 12 },
  { value: 'description', label: 'Descripción completa', component: VTextarea, col: 12 },

  { value: 'featured_image', label: 'Imagen destacada', component: VTextField, col: 6 },
  { value: 'image_gallery', label: 'Galería de imágenes', component: VTextField, col: 6 },
  { value: 'media_gallery', label: 'Galería multimedia', component: VTextField, col: 6 },

  { value: 'model', label: 'Modelo', component: VTextField, col: 6 },
  { value: 'year', label: 'Año', component: VTextField, type: 'number', col: 6 },

  { value: 'transmission', label: 'Transmisión', component: VSelect, options: ['Manual', 'Automática'], col: 6 },
  { value: 'color', label: 'Color', component: VTextField, col: 6 },

  { value: 'doors', label: 'Puertas', component: VTextField, type: 'number', col: 6 },
  { value: 'cilinders', label: 'Cilindros', component: VTextField, type: 'number', col: 6 },

  { value: 'interior', label: 'Interior', component: VTextField, col: 6 },
  { value: 'interior_color', label: 'Color interior', component: VTextField, col: 6 },

  { value: 'serial_number', label: 'Nº de serie', component: VTextField, col: 6 },
  { value: 'is_armored', label: 'Blindado', component: VSwitch, col: 6 },

  {
    value: 'make_id',
    label: 'Marca',
    component: VAutocomplete,
    searchValue: 'name',
    fetchOptions: 'getCarMakes',
    itemText: 'name',
    itemValue: 'id',
    required: true,
    col: 6
  },
  {
    value: 'branch_id',
    label: 'Sucursal',
    component: VAutocomplete,
    searchValue: 'name',
    fetchOptions: 'getBranches',
    itemText: 'name',
    itemValue: 'id',
    required: true,
    col: 6
  },
];

export const HEADERS = [
  { title: 'Id', value: 'id', format:'text', sortable: true },
  { title: 'Titulo', value: 'title', format:'text', sortable: true },
  { title: 'Auto', value: 'car', format:'text', sortable: true },
  { title: 'Publicado', value: 'is_published', format:'text', sortable: true },
  { title: 'Precio', value: 'price', format: 'currency', sortable: true },
  { title: 'Precio de descuento', value: 'discount_price', format: 'currency', sortable: true },
  { title: 'Enganche', value: 'down_payment', format: 'currency', sortable: true },
  { title: 'Descripción corta', value: 'short_description', format:'text', sortable: true },
  { title: 'Sucursal', value: 'branch', format:'text', sortable: true },
  { title: 'Imagen', value: 'featured_image', format:'text', sortable: true },
  { title: 'Usuario', value: 'user', format:'text', sortable: true },
  { title: 'Kilometraje', value: 'mileage', format: 'decimal', sortable: true },
  { title: 'Nº serie de motor', value: 'engine_serial_number', format:'text', sortable: true },
  { title: 'Marca', value: 'make.name', format:'text', sortable: true },
  { title: 'Nº VIN', value: 'vin_number', format:'text', sortable: true },
  { title: 'Modelo', value: 'model', format:'text', sortable: true },
  { title: 'Año', value: 'year', format:'text', sortable: true },
  { title: 'Transmisión', value: 'transmission', format:'text', sortable: true },
  { title: 'Color', value: 'color', format:'text', sortable: true },
  { title: 'Puertas', value: 'doors', format:'text', sortable: true },
  { title: 'Cilindros', value: 'cilinders', format:'text', sortable: true },
  { title: 'Interior', value: 'interior', format:'text', sortable: true },
  { title: 'Color de interior', value: 'interior_color', format:'text', sortable: true },
  { title: 'Nº de serie', value: 'serial_number', format:'text', sortable: true },
  { title: 'Blindado', value: 'is_armored', format:'text', sortable: true },
];

export const DEFAULT_HEADER_ORDER = [
  'make.name',
  'model',
  'year',
  'mileage',
  'price',
  'discount_price'
];

export const DETAIL = {
  expand_table: false,
  eye_detail: true,
  key: 'all',
  component: undefined
};

export const FILTERS = [
  {
    value: 'title',
    label: 'Título',
    component: VTextField,
    placeholder: 'Buscar por título',
  },
  {
    value: 'year',
    label: 'Año',
    component: VSelect,
    options: [2025, 2024, 2023, 2022],
  },
  {
    value: 'make_id',
    label: 'Marca',
    component: VAutocomplete,
    searchValue: 'name',
    fetchOptions: 'getCarMakes',
    itemText: 'name',
    itemValue: 'id',
  }
];